<div class="tab-nav">
    <a (click)="showNavOptions = !showNavOptions" class="mobile-link">Menu</a>
    <ul [ngClass]=" showNavOptions ? 'nav-visible' : ''">
        <li *ngFor="let item of menu; let i=index"
        [ngClass]="{'selected': ((fullMatch && item.link == currentRoute) || (!fullMatch && selectedItem != null && selectedItem.title == item.title)), 'disabled': item.disabled, 'last': (i+1) == menu.length }">
          <em class="arrow-down"></em>
          <a [hidden]="item.disabled" [routerLink]="[item.link]" (click)="onClick(item)">
            <em>{{item.title}}</em>
          </a>
          <em [hidden]="!item.disabled">{{item.title}}</em>
          <span></span>
        </li>
    </ul>
</div>
